import axios from 'axios';
import headers from "../Header";

let baseUrl = "/sdpi/data-konfirmasi"

class DataKonfirmasiService {
    getDataKonfirmasiNomorKk(size, page, param) {
        let url=""
        if(param){
            url = baseUrl + "/nomor-kk?size="+size+"&page=" + page+"&"+param
        }else{
            url = baseUrl + "/nomor-kk?size="+size+"&page=" + page
        }
        return axios.get(url, {
            headers: headers(),
        });
    }

    getDataKonfirmasiNik(kode_prov, kode_kab, kode_kec, kode_desa) {
        let param = ""

        if (kode_prov) {
            param = "?kode_prov=" + kode_prov
        } else if (kode_kab) {
            param = "?kode_kab=" + kode_kab
        } else if (kode_prov) {
            param = "?kode_kec=" + kode_kec
        } else if (kode_prov) {
            param = "?kode_desa=" + kode_desa
        }
        return axios.get(baseUrl + "/nik" + param, {
            headers: headers(),
        });
    }

    getDataKonfirmasiSearch(nik, nomor_kk) {
        let param = ""

        if (nik) {
            param = "?nik=" + nik
        } else if (nomor_kk) {
            param = "?nomor_kk=" + nomor_kk
        }
        return axios.get(baseUrl + "/search" + param, {
            headers: headers(),
        });
    }

    getDataKonfirmasiSearchByKodeSlsAndNama(kode_sls, nama) {
        return axios.get(baseUrl + "/search-by-kode-sls-and-nama?kode_sls=" + kode_sls+"&nama="+nama, {
            headers: headers(),
        });
    }

    searchByNama(page, q) {
        let param = ""
        if(page){
            param = "&page="+page
        }
        return axios.get(baseUrl + "/search-by-nama?q="+q+""+param, {
            headers: headers(),
        });
    }

    searchByNomorKk(page, q) {
        let param = ""
        if(page){
            param = "&page="+page
        }
        return axios.get(baseUrl + "/search-by-nomor-kk?q="+q+""+param, {
            headers: headers(),
        });
    }

}

export default new DataKonfirmasiService();